import React from 'react';
import { Space, Tooltip } from 'antd';
import { LayoutOutlined } from '@ant-design/icons';
import Drilldown from '@src/components/widget-panel/control/Drilldown';
import RemoveWidget from '@src/components/widget-panel/control/RemoveWidget';
import useDrillDownToPreset from '@src/components/widget-panel/hooks/useDrilldownToPreset';
import { StyledSwitch } from '../../styled';

const Extra = ({
  showTreeMap,
  setShowTreeMap,
  widgetHandler,
  metrics = [],
  showOptions = true,
}) => {
  const handleAction = useDrillDownToPreset({ category: 'network', metrics });

  const handleChange = () => {
    setShowTreeMap(!showTreeMap);
  };
  return (
    <Space>
      {showOptions && (
        <>
          <Tooltip title="Toggle View">
            <StyledSwitch
              style={{ verticalAlign: 'sub' }}
              size="small"
              checkedChildren={<LayoutOutlined />}
              unCheckedChildren={<LayoutOutlined />}
              checked={showTreeMap}
              onChange={handleChange}
            />
          </Tooltip>
          <Drilldown createDashboard={handleAction} />
        </>
      )}
      <RemoveWidget onClick={widgetHandler.remove} />
    </Space>
  );
};

export default Extra;
